import { useParams } from 'react-router-dom'
import { useState, useEffect, useContext } from 'react'
import Slider from '../blocks/slider/Slider'
import Image from '../blocks/image/Image'
import Text from '../blocks/text/Text'
import Video from '../blocks/video/Video'
import Map from '../blocks/map/Map'
import Meta from '../common/meta/Meta'
import Loader from '../common/loader/Loader'
import Grid from '../common/grid/Grid'
import { PageDataContext } from '../../context/PageDataContext'

const Page = ({ pageSummaries, isHome, currentLocale }) => {
    let { locale, slug, parentslug } = useParams()
    const { getPageData } = useContext(PageDataContext)
    const [currentPage, setCurrentPage] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const notFound = <div></div>

    useEffect(() => {
      let isActive = true
      setIsLoading(true)
      setCurrentPage([])
      getPageData({ locale, slug, parentslug, isHome })
        .then((data) => {
          if (!isActive) return
          setCurrentPage(Array.isArray(data) ? data : [])
          setIsLoading(false)
        })
        .catch((error) => {
          console.error('Page: Failed to load page data', error)
          if (!isActive) return
          setCurrentPage([])
          setIsLoading(false)
        })

      return () => {
        isActive = false
      }
    }, [locale, slug, parentslug, isHome, getPageData])

    
  
    return (
      <>
        {isLoading && <Loader />}
        {!isLoading && currentPage.length < 1 ? notFound : ''}
        {!isLoading && currentPage.map((page, index) => {
          // Safety check: ensure page exists and is an object
          if (!page || typeof page !== 'object') {
            return null;
          }
          
          return (
          <>
              <div key={page.id || page.documentId || index}>
                <Meta page={page} locale={currentLocale} />
                {(page.is_category_grid_page || page.is_home) ? 
                <section key={index} id={page.slug} className="project-grid">
                  <Grid 
                    isHome = {page.is_home}
                    gridData={pageSummaries} 
                    isCategoryGridPage={page.is_category_grid_page} 
                    gridPageCategory={{ ...(page.category || {}), locale: page.locale }}
                    currentLocale={page.locale} />
                </section>
                :
                <section key={index} id={page.slug} 
                className={`page-grid page-${page.slug} ${page.rows && Array.isArray(page.rows) && page.rows.length > 0 && 
    page.rows[0].__component === 'block-type.image' ? '' : ''}`}>
                  
                  <div className="container-fluid">
                    <>
                      {page.rows && Array.isArray(page.rows) && page.rows.map((row, rowIndex) => {
                        if (!row || typeof row !== 'object') return null;
                        
                        return (
                        <div key={rowIndex} className="block-row">
                            {row.__component === 'block-type.image' && 
                              <Image pageData={page} isSingleImage imageData={row} /> 
                            }
                            {row.__component === 'block-type.text' && 
                              row.text && <Text pageData={page} textData={row} />
                            }
                            {row.__component === 'block-type.text-video' &&
                              <>
                                {row.is_reverse_order ? (
                                  <>
                                    {row.video && row.video.video_url && <Video pageData={page} videoURL={row.video.video_url} />} 
                                    {row.text && <Text pageData={page} textData={row.text} />}
                                  </>) : (<>
                                    {row.text && <Text pageData={page} textData={row.text} />}
                                    {row.video && row.video.video_url && <Video pageData={page} videoURL={row.video.video_url} />} 
                                  </> )}
                              </>
                            }
                            {row.__component === 'block-type.image-text' &&
                              <>
                                {row.is_reverse_order ? (
                                  <>
                                    {row.text && <Text pageData={page} textData={row.text} />}
                                    {row.image && <Image pageData={page} imageData={row.image} />} 
                                  </>) : (<>
                                    {row.image && <Image pageData={page} imageData={row.image} />} 
                                    {row.text && <Text pageData={page} textData={row.text} />}
                                  </>)}
                              </>
                            }
                            {row.__component === 'block-type.image-image' &&
                              <>
                                {row.images && Array.isArray(row.images) && row.images.map((imageData, index) => (
                                  imageData && <Image key={index} pageData={page} imageData={imageData} />
                                ))}
                              </>
                            }
                            {row.__component === 'block-type.text-text' &&
                              <>
                                {row.texts && Array.isArray(row.texts) && row.texts.map((textData, index) => (
                                  textData && <Text key={index} pageData={page} textData={textData} />
                                ))}
                              </>
                            }
                            {row.__component === 'visual-components.slider' &&
                              <>
                                {row.slides && Array.isArray(row.slides) && <Slider slides={row.slides} />}
                              </>
                            }
                            {row.__component === 'visual-components.map' &&
                              <>
                                <Map pageData={row} />
                              </>
                            }
                        </div>
                        );
                      })}
                    </>
                  </div>
                </section>
                }
                
            </div> 
          </>
          );
        })}
      </>
    )
}

export default Page
